import { useGetDeliveryStopsPod } from "api/queries/shipments/useGetDeliveryStopsPod";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import { DeliveryStopPod } from "api/response";
import { FEATURE_FLAGS } from "constants/featureFlags";
import { ShipmentTypes } from "constants/";
import useFeatureFlag from "hooks/useFeatureFlag";

export type TrackingStopAssociation = {
  /** Tracking numbers can only be associated to a stop on multistop shipments with delivery stops. */
  isEnabled: boolean;
  stops: DeliveryStopPod[];
};

export function useTrackingStopAssociation(shipmentId?: string): TrackingStopAssociation {
  const { data: shipmentBasicData } = useGetShipmentBasic(shipmentId ?? "", {
    enabled: !!shipmentId,
    refetchOnMount: false,
  } as any);
  const isMultistop = shipmentBasicData?.shipment?.shipment_type === ShipmentTypes.MULTISTOP;
  const isMultistopPodEnabled = useFeatureFlag(FEATURE_FLAGS.WEB_10959_MULTISTOP_POD);
  const isMultistopPodShipment = isMultistop && isMultistopPodEnabled;

  const { data } = useGetDeliveryStopsPod(shipmentId ?? "", {
    enabled: !!shipmentId && isMultistopPodShipment,
    refetchOnMount: false,
  });

  const stops = data?.stops ?? [];

  return { isEnabled: isMultistopPodShipment && stops.length > 0, stops };
}

export default useTrackingStopAssociation;
